import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=2e50c6c7&scoped=true&lang=pug&"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=2e50c6c7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50c6c7",
  null
  
)

export default component.exports